import type { User as SupabaseUser } from "@supabase/supabase-js";
import type { User as AppUser } from "@/types/user";

export const convertSupabaseUser = (
	supabaseUser: SupabaseUser | null,
): AppUser | null => {
	if (!supabaseUser) return null;

	return {
		id: supabaseUser.id,
		email: supabaseUser.email || "",
		username: supabaseUser.user_metadata?.username || "",
		createdAt: supabaseUser.created_at || "",
		updatedAt: supabaseUser.updated_at || "",
		isActive: true,
		role: "user",
	};
};
